"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _Caption = _interopRequireDefault(require("./Caption"));

var _utils = require("../utils"); // import app components


var PostTreeSelect = function PostTreeSelect(props) {
  var _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items,
      value = props.value,
      label = props.label,
      onChange = props.onChange;
  var treePosts = (0, _utils.createDataTree)(items);

  var renderTreeNode = function renderTreeNode(item) {
    return /*#__PURE__*/_react.default.createElement(_antd.TreeSelect.TreeNode, {
      key: item.id,
      value: item.id,
      title: item.title
    }, item.childNodes.map(function (o) {
      return renderTreeNode(o);
    }));
  };

  return /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 6
  }, /*#__PURE__*/_react.default.createElement(_Caption.default, {
    children: label
  }), /*#__PURE__*/_react.default.createElement(_antd.TreeSelect, {
    showSearch: true,
    treeNodeFilterProp: "title",
    value: value,
    dropdownStyle: {
      maxHeight: 400,
      overflow: 'auto'
    },
    allowClear: true,
    treeDefaultExpandAll: true,
    onChange: onChange
  }, /*#__PURE__*/_react.default.createElement(_antd.TreeSelect.TreeNode, {
    value: 0,
    title: "None"
  }), treePosts.map(function (o) {
    return renderTreeNode(o);
  })));
};

var _default = PostTreeSelect;
exports.default = _default;